// extracted by mini-css-extract-plugin
module.exports = {"arrowLeftButton":"components-base-Button-Icons-ArrowLeftButton-ArrowLeftButton__arrowLeftButton--1cNwo"};